import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button } from "@mui/material";
import { CError } from "app/common/CError";
import { Loading } from "app/lib/components/Loading";
import { makeNonEmpty } from "core/util/array";
import { useIndueCardDetailsQuery, useIndueCardsandAssociationsByAccountQuery, } from "generated/generated-models";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import IndueCardDetailsPage from "./IndueCardDetailsPage";
import IndueCardListTable from "./IndueCardListTable";
const requestCardError = (queryResult) => {
    const cards = makeNonEmpty(queryResult?.indueCardsByAccount);
    const association = queryResult?.partyAssociationByAccount;
    const authority = queryResult?.accountByIdOrNumber?.CurrentUserAccountAuthority;
    if (!authority?.Operate) {
        return "You do not have permission to order a card";
    }
    if (association?.IsSecondaryBorrower &&
        !association.PrimaryBorrowerHasCard &&
        cards?.length === 0) {
        return "You cannot order a card until the Primary Borrower has a non-closed card for the account";
    }
    if (association?.IsNonBorrower && cards?.length === 0) {
        return "Only borrowers can order a card for the account";
    }
    return undefined;
};
const RequestCard = ({ queryResult, cardAvailable, }) => {
    const navigate = useNavigate();
    const cards = makeNonEmpty(queryResult?.indueCardsByAccount);
    if (!cardAvailable || cards.length !== 0) {
        return null;
    }
    const errorMessage = requestCardError(queryResult);
    if (errorMessage != null) {
        return (_jsxs(_Fragment, { children: [_jsx(Alert, { severity: "warning", children: errorMessage }), _jsx(Button, { variant: "contained", disabled: true, id: "requestCardButton", children: "Request Card" })] }));
    }
    return (_jsx(Button, { id: "requestCardButton", onClick: () => navigate("RequestCard"), variant: "contained", children: "Request Card" }));
};
const IndueCardListPage = ({ accountId, cardAvailable }) => {
    const { number: accountNumber } = useParams();
    const { data, loading, error } = useIndueCardsandAssociationsByAccountQuery({
        variables: { accountId: accountId, accountIdString: accountId },
        fetchPolicy: "network-only",
    });
    const [selectedCard, setSelectedCard] = useState();
    const indueCards = makeNonEmpty(data?.indueCardsByAccount);
    const { data: dataCardDetails } = useIndueCardDetailsQuery({
        variables: { input: { CardId: selectedCard } },
        fetchPolicy: "network-only",
    });
    const card = dataCardDetails?.indueCardDetails;
    React.useEffect(() => {
        if (!loading && data) {
            const indueCards = makeNonEmpty(data?.indueCardsByAccount);
            if (indueCards.length > 0) {
                const firstCard = indueCards[0].Id;
                setSelectedCard(firstCard);
            }
        }
    }, [loading, data]);
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsx(CError, { error: "Could not retrieve card details" });
    }
    return (_jsxs("div", { className: "main-content sub-wrap cardPage", children: [_jsxs("div", { className: "title-row-with-button", children: [_jsxs("div", { className: "list-header", children: [_jsx("h2", { children: "Cards" }), _jsxs("span", { className: "list-subhead", children: ["For Account: ", accountNumber] })] }), _jsx(RequestCard, { queryResult: data, cardAvailable: cardAvailable })] }), _jsxs("div", { className: "cardsContainer", children: [_jsx(IndueCardListTable, { accountNumber: accountNumber ?? "", cards: makeNonEmpty(indueCards), handleOnSelectedCard: selectedCard }), selectedCard !== undefined && (_jsx(IndueCardDetailsPage, { cardId: selectedCard, indueCardProps: card }))] })] }));
};
export default IndueCardListPage;
